import React from 'react';

import pick from 'lodash/pick'

import useClient from '@lib/hooks/useClient';

import { KLineH5 } from '../KLineH5';
import { useKLineHeader } from '../KLineHeader/useKLineHeader'
import { TradeWebTop } from '../TradeWebTop';

export const KLineMain = (props) => {
  const isPc = useClient()
  const kLineHeaderProps = useKLineHeader({ precision: props.precision, coinDetail: props.tradeCoinDetail, midPrice: props.midPrice, midPriceRise: props.midPriceRise })
  if (isPc === '') {
    return
  }

  return (
    <>
      {isPc && <TradeWebTop {...props} kLineHeaderProps={{
        ...kLineHeaderProps,
        ...pick(props, 'coinArr', 'isFavorite', 'favoriteChange', 'coinDetail')
      }} />}
      {!isPc && <KLineH5 {...props} kLineHeaderProps={{
        ...kLineHeaderProps,
        ...pick(props, 'coinArr', 'isFavorite', 'favoriteChange', 'coinDetail')
      }} />}
    </>
  )
}
